import { colors } from '../../variables.style'

import { createUseStyles } from 'react-jss'

export const style = {
  emptyState: {
    border: `2px dashed ${colors.brandDark}`,
    width: '460px',
    height: '340px',
    display: 'flex'
  },
  messageContainer: {
    margin: 'auto',
    textAlign: 'center'
  },
  logo: {
    width: '80px',
    height: '80px'
  },
  message: {
    margin: '48px 20px 40px 20px',
    fontSize: '18px'
  },
  messageWithoutButton: {
    extend: 'message',
    marginBottom: 0
  }
}

export const useStyles = createUseStyles(style)
